import { makeVar } from '@apollo/client'

export const listingPageReactiveVar = makeVar({
    isLoading: false,
    hasNextPage: true,
})

export const setIsListingLoading = (isLoading: boolean) => {
    const current = listingPageReactiveVar()
    listingPageReactiveVar({ ...current, isLoading })
}

export const setHasNextPage = (hasNextPage: boolean) => {
    const current = listingPageReactiveVar()

    if (hasNextPage === current.hasNextPage) {
        return
    }

    listingPageReactiveVar({ ...current, hasNextPage })
}
